import { GetUsersMe200ResponseAvailableFeaturesEnum } from '@src/api/generated/user-api'
import {
  getAvailableFeatures,
  getFreeeCompanyId,
  getIsBookkeeper,
  getIsGeneralUser,
  getIsJournalFeatureEnabled,
  getIsOrganizationAdmin,
  getIsSystemAdmin,
  getIsViewer,
} from '@src/utils'
import { isPresident } from '@src/utils/brand'

export function canReadAccounting() {
  const isFreeeConnected = !!getFreeeCompanyId()
  return (
    isFreeeConnected &&
    (getIsOrganizationAdmin() ||
      getIsBookkeeper() ||
      (getIsViewer() && getIsJournalFeatureEnabled()))
  )
}

export function canReadAdminNavDrawer() {
  return getIsOrganizationAdmin() || getIsBookkeeper() || getIsViewer()
}

export function canReadGeneralUserNavDrawer() {
  return getIsGeneralUser()
}

export function canReadMemoTemplate() {
  return getIsViewer()
}

export function canReadZeus() {
  return getIsSystemAdmin()
}

export function canWriteAccounting() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWriteCardRole() {
  return getIsOrganizationAdmin()
}

export function canWriteCompanySetting() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWriteEmailNotification() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWriteMemoTemplate() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWritePurchaseApplication() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWriteSso() {
  return getIsOrganizationAdmin()
}

export function canWriteSlackNotification() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWriteTeamsNotification() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canUseAvailableFeature(
  value: GetUsersMe200ResponseAvailableFeaturesEnum
) {
  return getAvailableFeatures().includes(value)
}

export function canWriteMerchantComment() {
  return !getIsViewer()
}

export function canWriteTermsAgreement() {
  return getIsOrganizationAdmin() && !isPresident()
}

export function canWriteWithholding() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWritePaymentRequest() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canReadDraftPaymentRequest() {
  return getIsOrganizationAdmin() || getIsBookkeeper() || getIsGeneralUser()
}

export function canReadAllPaymentRequest() {
  return getIsOrganizationAdmin() || getIsBookkeeper() || getIsViewer()
}

export function canReadEvidenceStatus() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWriteCardTransactionComment() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canWriteBalanceWithdrawal() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}

export function canAccessUpsiderCredit() {
  return getIsOrganizationAdmin() || getIsBookkeeper()
}
